import { Flex } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentHtmlPreview } from '@features/invoices/elements/DocumentHtmlPreview'
import { InvoicePreviewRibbon } from '@features/invoices/elements/InvoicePreviewRibbon'

import * as Styled from './styles'

interface DemoInvoicePreviewProps {
  htmlFiles?: string[]
  isLoading: boolean
}

export const DemoInvoicePreview = ({ htmlFiles, isLoading }: DemoInvoicePreviewProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex justifyContent="center">
      <Styled.PreviewWrapper>
        {!isLoading && <InvoicePreviewRibbon text={t('demo_invoice.ribbon')} variant="lavender" />}
        <Flex justifyContent="center">
          <DocumentHtmlPreview htmlFiles={htmlFiles} isLoading={isLoading} />
        </Flex>
      </Styled.PreviewWrapper>
    </Flex>
  )
}
